module.exports = __webpack_public_path__ + "img/cm.2939c2f3.svg";